module.exports = __webpack_public_path__ + "img/2_market_approval.e0600fbc.svg";